import { DashworksReconnectButton } from '../../components/reconnectButton/DashworksReconnectButton';
import { AppConnectionStatuses } from '../../constants/appConnectionStatuses';
export const DashworksReconnectionConfig = {
  reconnectButton: DashworksReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED]
};